<div class="card panel-flat-color secondary-panel">
    <div class="panel-flat-header pointer" role="button" tabindex="0"
         (click)="expandOrCollapse()"
         (keydown.enter)="expandOrCollapse()"
         (keydown.space)="expandOrCollapse()">
        <panel-chevron [showBody]="showBody"></panel-chevron>
        <h3>Equalization Factors</h3>
    </div>
    @if (showBody) {
        <div class="panel-flat-body">
            <div style="height: 300px;">
                <ws-ag-grid-angular
                    [gridId]="gridId"
                    [gridOptions]="gridOptions"
                    (gridReady)="onAgGridReady($event)">
                </ws-ag-grid-angular>
            </div>
            @if (hasEditPermission) {
                <div class="d-flex align-items-center mt-3">
                    <button type="button" class="ace-btn btn-sm btn-primary" (click)="newEqualizationRule()">
                        New Eq. Factor
                    </button>
                </div>
            }
        </div>
    }
</div>
